import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import massiveWall1 from "./components/massive-wall-1";
import massiveWall2 from "./components/massive-wall-2";
import lightweightWall1 from "./components/lightweight-wall-1";
import lightweightWall2 from "./components/lightweight-wall-2";

const principle: Slide = {
  description:
    "Choose between different wall structures and see the most important data about them. Listen to everyday sounds in their original form and as they would be perceived through a wall. Use headphones. Set the volume on your device so that original male voice sounds realistically loud.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [
            { name: "Massive wall 1" },
            { name: "Massive wall 2" },
            { name: "Lightweight wall 1" },
            { name: "Lightweight wall 2" },
          ],
        },
      ],
      controlsPosition: "top",
      extraContent: [[], [], [], []],
      components: [massiveWall1, massiveWall2, lightweightWall1, lightweightWall2],
    },
  },
};

export default principle;
